import * as React from "react";
import { createRoot } from "react-dom/client";
import "@utils/createSentry";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import UserContainer from "@utils/state/userContainer";
import App from "./App";
import posthog from 'posthog-js';
import { useEffect } from 'react';

export const queryClient = new QueryClient();

// Initialize PostHog
posthog.init('phc_h91ZcEFMQXfjPhL9NL8RdmEkhqVBba7kxdQhncCazHt', {
  api_host: 'https://us.posthog.com',
  autocapture: false,
  capture_pageview: false,
  capture_performance: {web_vitals: false},
  capture_heatmaps: false,
  capture_pageleave: false,
  capture_exceptions: false,
  before_send: (event) => {
    // Block unwanted events
    if (event.event === '$set' || event.event === '$identify') {
      return null;
    }
    return event;
  },
});

function PostHogPageViewTracker(): null {
  const location = useLocation();
  useEffect(() => {
    posthog.capture('$pageview');
  }, [location.pathname]);
  return null;
}

const AppWrapper = (): JSX.Element => (
  <UserContainer.Provider>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <Router>
        <PostHogPageViewTracker />
        <App />
      </Router>
    </QueryClientProvider>
  </UserContainer.Provider>
);

const container = document.getElementById("root");
const root = createRoot(container);

// eslint-disable-next-line react/react-in-jsx-scope
root.render(<AppWrapper />);
